import React, { useState, useEffect } from 'react';
import { ArrowUp } from 'lucide-react';
import { scrollToSection } from '../utils/scroll';

const ScrollToTop = () => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const toggleVisibility = () => {
      const footer = document.getElementById('footer');
      if (footer) {
        const footerPosition = footer.getBoundingClientRect().top;
        const windowHeight = window.innerHeight;
        
        // Show button when footer is in view
        setIsVisible(footerPosition <= windowHeight);
      }
    };

    window.addEventListener('scroll', toggleVisibility);
    return () => window.removeEventListener('scroll', toggleVisibility);
  }, []);

  const handleClick = (e: React.MouseEvent<HTMLButtonElement>) => {
    e.preventDefault();
    scrollToSection('top');
  };

  return (
    <button
      onClick={handleClick}
      className={`fixed md:left-1/2 md:-translate-x-1/2 right-4 md:right-auto bottom-24 md:bottom-24 bg-gradient-to-r from-cyan-500 to-cyan-600 hover:from-cyan-600 hover:to-cyan-700 text-white px-5 py-2.5 rounded-full shadow-lg transition-all duration-300 transform hover:scale-105 md:hover:-translate-y-1 z-20 md:z-50 flex items-center gap-2 ${
        isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10 pointer-events-none'
      }`}
      aria-label="Scroll to top"
      style={{ pointerEvents: isVisible ? 'auto' : 'none' }}
    >
      <span className="text-sm font-medium hidden sm:inline">Back to Top</span>
      <ArrowUp className="h-5 w-5" />
    </button>
  );
};

export default ScrollToTop; 